import React from 'react';
import { observer } from 'mobx-react';
import { Row, Col } from 'antd';
import useAsyncEffect from '@app/hooks/useAsyncEffect';
import { useStores } from '@app/hooks/stores';
import TenantsList from './TenantsList';
import SubTenantsList from './SubTenantsList';

const Tenants: React.FC = () => {
  const { profilesStore, cronProfilesStore } = useStores();

  useAsyncEffect(profilesStore.getProfiles, [profilesStore.listProfiles.length === 0]);
  useAsyncEffect(cronProfilesStore.getCronProfiles, [cronProfilesStore.listCronProfiles.length === 0]);

  if (profilesStore.listProfiles.length === 0) return null;

  return (
    <Row gutter={24}>
      <Col lg={10} md={10} sm={24}>
        <TenantsList profilesList={profilesStore.listProfiles} />
      </Col>
      <Col lg={14} md={14} sm={24}>
        <SubTenantsList />
      </Col>
    </Row>
  );
};
export default observer(Tenants);
